// extracted by mini-css-extract-plugin
export default {"Spinner":"Spinner_Spinner__lYQ84","load7":"Spinner_load7__ee0NI"};